import reducer from "./reducers"
export { default as memberActions } from "./actions"

export default reducer